var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canSeeSource && _vm.source)?_c('el-tag',{class:['source-badge', `source-${(_vm.source || '').toLowerCase()}`],attrs:{"type":_vm.tagType,"size":"mini","effect":"plain"}},[_c('i',{class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }